/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExposeBadgeCategory
 */
export interface ExposeBadgeCategory {
    /**
     * 뱃지 카테고리 id
     * @type {number}
     * @memberof ExposeBadgeCategory
     */
    'badgeCategoryId': number;
    /**
     * 종류
     * @type {string}
     * @memberof ExposeBadgeCategory
     */
    'type': ExposeBadgeCategoryTypeEnum;
    /**
     * 설명
     * @type {string}
     * @memberof ExposeBadgeCategory
     */
    'description': string;
    /**
     * 보너스 포인트
     * @type {number}
     * @memberof ExposeBadgeCategory
     */
    'bonusPoint': number;
}

export const ExposeBadgeCategoryTypeEnum = {
    StartViewup: 'start_viewup',
    SavingJoy: 'saving_joy',
    Reach10000P: 'reach_10,000P',
    AchieveInstallationReview: 'achieve_installation_review',
    AchievePostingReview: 'achieve_posting_review',
    ViewupHolic: 'viewup_holic',
    WritingFun: 'writing_fun',
    SympathyKing: 'sympathy_king',
    CommentKing: 'comment_king'
} as const;

export type ExposeBadgeCategoryTypeEnum = typeof ExposeBadgeCategoryTypeEnum[keyof typeof ExposeBadgeCategoryTypeEnum];


